import React from 'react'
import Logins from '../Component/Login/Logins'
import HeroLogin from '../Component/Login/HeroLogin'

const Loginn = () => {
    return (
        <>
        <HeroLogin/>
        <Logins/>
            
        </>
    )
}

export default Loginn
